import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { meQuery } from "@/lib/queries";
import { buttonStyles } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const Route = createFileRoute("/")({
  component: HomePage,
  loader: ({ context }) => context.queryClient.ensureQueryData(meQuery),
});

function HomePage() {
  const { data } = useQuery(meQuery);
  const signedIn = !!data?.user;

  return (
    <section className="mx-auto mt-10 max-w-md space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>All aboard.</CardTitle>
          <p className="font-mono text-xs text-muted-foreground">
            mextrain scores Mexican Train dominoes by camera. Snap a photo of
            the leftover tiles, the app totals the round.
          </p>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-stretch gap-3">
            <Link
              to="/games/create"
              className={buttonStyles("primary", "lg", "w-full")}
            >
              Start a new game
            </Link>
            {!signedIn && (
              <Link
                to="/login"
                className="text-center font-mono text-sm text-muted-foreground underline-offset-2 hover:text-foreground hover:underline"
              >
                or sign in to keep your stats
              </Link>
            )}
          </div>
        </CardContent>
      </Card>

      {data && data.players.length > 0 && (
        <section>
          <h2 className="font-display text-2xl mb-3">Continue a game</h2>
          <ul className="space-y-3">
            {data.players.map((p) => (
              <li key={p.id}>
                <Link
                  to="/games/$id/lobby"
                  params={{ id: p.gameId }}
                  className="block"
                >
                  <Card className="transition-colors hover:border-rust-500/60">
                    <div className="flex items-center justify-between gap-3">
                      <div>
                        <div className="font-display text-xl">
                          {p.displayName}
                        </div>
                        <div className="font-mono text-xs text-muted-foreground">
                          game {p.gameId}
                        </div>
                      </div>
                      <span className="font-mono text-sm text-rust-600">
                        Continue →
                      </span>
                    </div>
                  </Card>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}
    </section>
  );
}
